import { isDefined } from "@omni/utils/helper.utils";
import { RefObject } from "react";

import { useWoosmapScript } from "@/services/woosmap/woosmap.initializer";
import { Config } from "@/utils/config.utils";
import { ScriptLoadingStates } from "@/utils/hooks/useScript.hook";

import { ZOOM_INITIAL } from "../storeSearch.config";

let map: woosmap.map.Map | undefined;

export const useMap = (mapElementRef: RefObject<HTMLDivElement | null>) => {
    const woosmapScriptLoadingState = useWoosmapScript();
    const ready = woosmapScriptLoadingState === ScriptLoadingStates.Ready;

    const createMap = () => {
        if (isDefined(map)) return;
        if (!isDefined(mapElementRef.current)) return;
        if (!ready) return;

        map = new woosmap.map.Map(mapElementRef.current, {
            center: {
                lat: Config.integrations["google-maps-site-lat"],
                lng: Config.integrations["google-maps-site-long"]
            },
            zoom: ZOOM_INITIAL
        });
    };

    createMap();

    return map;
};
